import axios from "axios";
import { mua } from "../../config/api";

import { Button, FloppyDiskIcon, Pane, SelectField, Text } from "evergreen-ui";
import React, { useState } from "react";
import { useEffect } from "react";

function FormRegisterMaster() {
  const [Chk, setChk] = useState(false);
  const [DataFaculty, setDataFaculty] = useState([]);
  useEffect(() => {
    if (Chk === false) {
      // if(localStorage.getItem('typestudent') === "3"){
      //   localStorage.setItem('typestudent',"4")
      // }else if(localStorage.getItem('typestudent') === "4"){
      //   localStorage.setItem('typestudent',"7")
      // }
      GetFaculty();
    }
  });
  useEffect(() => {}, [Chk]);
  const GetFaculty = async (params) => {
    try {
      const fetch = await axios.post(
        mua + "/admissionnew2022/showfaculty",
        {
          typestudent: localStorage.getItem("typestudent") === "3" ? "4" : "7",
          level: localStorage.getItem("level"),
          vga: localStorage.getItem("vga"),
          plan: localStorage.getItem("plan"),
          typestd: localStorage.getItem("typestudent") === "3" ? "4" : "7",
          level_saka: "1",
          faculty: "",
          faculty2: "",
          faculty3: "",
          courseyear: "1",
        }
      );
      const data = fetch.data.data.data;
      if (data.length !== 0) {
        const datafac = [];
        data.forEach((i) => {
          datafac.push({ value: i.id_fac, label: i.faculty_name });
        });
        setDataFaculty(datafac);
      }

      setChk(true);
    } catch (error) {}
  };
  const single = [
    {
      value: "1",
      label: "กลุ่มวิชาฟิสิกส์",
    },
    {
      value: "2",
      label: "กลุ่มวิชาเคมี",
    },
    {
      value: "3",
      label: "กลุ่มวิชาชีววิทยา",
    },
    {
      value: "4",
      label: "กลุ่มวิชาวิยาศาสตร์ทั่วไป",
    },
    {
      value: "5",
      label: "กลุ่มวิชาคณิตศาสตร์",
    },
  ];
  const plan = [
    {
      value: "810",
      label: "วิทยาศาสตร์ศึกษา ( วิทยาศาสตรมหาบัณฑิต ) แบบวิชาการที่ 1 ",
    },
    {
      value: "811",
      label: "วิทยาศาสตร์ศึกษา ( วิทยาศาสตรมหาบัณฑิต ) แบบวิชาการที่ 2 ",
    },
  ];
  const [DataMajor, setDataMajor] = useState([]);
  const [Faculty, setFaculty] = useState("");
  const [Major, setMajor] = useState("");
  const [Maj, setMaj] = useState("");
  const onChangeFaculty = async (e) => {
    try {
      const name = e.target.name;
      const value = e.target.value;
      setFaculty(value);
      let bodydata = {
        typestudent: localStorage.getItem("typestudent") === "3" ? "4" : "7",
        level: localStorage.getItem("level"),
        plan: localStorage.getItem("plan"),
        vga: localStorage.getItem("vga"),
        typestd: localStorage.getItem("typestudent") === "3" ? "4" : "7",
        level_saka: "1",
        faculty: value,
        faculty2: "",
        faculty3: "",
        saka1: "",
        saka2: "",
        saka3: "",
        courseyear: "1",
      };
      const fetch = await axios.post(
        mua + "/admissionnew2022/showsaka",
        bodydata
      );
      const data = fetch.data.data.data;
      console.log(data);
      if (data.length !== 0) {
        const maj = [];
        data.forEach((i) => {
          maj.push({
            value: i.MAJOR_ID,
            label: i.MAJOR_NAME + " (" + i.LEVEL_NAME + ")",
          });
        });
        setDataMajor(maj);
      }
    } catch (error) {}
  };
  const Submit = (params) => {
    let majj = "";
    if (Faculty === "1") {
      majj = Major + Maj;
    } else {
      majj = Major;
    }
    localStorage.setItem("typestd", localStorage.getItem("typestudent") === "3" ? "4" : "7");
    localStorage.setItem("typestd2", "");
    localStorage.setItem("typestd3", "");
    localStorage.setItem("faculty", Faculty);
    localStorage.setItem("faculty2", "");
    localStorage.setItem("faculty3", "");
    localStorage.setItem("majorid", majj);
    localStorage.setItem("majorid2", "");
    localStorage.setItem("majorid3", "");
    window.location.pathname = `${process.env.REACT_APP_BASENAME || ""}/Formprofile`;
  };

  return (
    <>
      <Pane className="container pt-3">
        <Text fontSize={22} fontWeight={500}>
          สมัครเรียนปริญญาโท มหาวิทยาลัยราชภัฏกำแพงเพชร
        </Text>
        <Pane
          className="p-2 mt-3 d-flex flex-wrap"
          boxShadow="0px 0px 12px #00000040"
          borderRadius={5}
        >
          <div className="col-12 pb-2">
            <Text color="black" fontSize={18} fontWeight={500}>
              สาขาวิชา/วิชาเอก/ที่ต้องการสมัครเรียน 
            </Text>
          </div>
          <div className="col-6">
            <SelectField label="เลือกคณะ" onChange={onChangeFaculty}>
              <option value="">--เลือกคณะ--</option>
              {Array.isArray(DataFaculty) &&
                DataFaculty.map((i) => <option value={i.value}>{i.label}</option>)}
            </SelectField>
          </div>
          {Faculty === "1" ? (
            <>
              <div className="col-6">
                <SelectField
                  label="เลือกแผนการเรียน"
                  onChange={(e) => {
                    setMajor(e.target.value);
                  }}
                >
                  <option value="">--เลือกแผนการเรียนที่ต้องการสมัครเรียน--</option>
                  {Array.isArray(plan) &&
                    plan.map((i) => <option value={i.value}>{i.label}</option>)}
                </SelectField>
              </div>
              <div className="col-6">
                <SelectField
                  label="เลือกวิชาเอก"
                  onChange={(e) => {
                    setMaj(e.target.value);
                  }}
                >
                  <option value="">--เลือกวิชาเอกที่ต้องการสมัครเรียน--</option>
                  {Array.isArray(single) &&
                    single.map((i) => <option value={i.value}>{i.label}</option>)}
                </SelectField>
              </div>
            </>
          ) : (
            <div className="col-6">
              <SelectField
                label="เลือกสาขาที่ต้องการสมัครเรียน"
                onChange={(e) => {
                  setMajor(e.target.value);
                }}
              >
                <option value="">--เลือกสาขาที่ต้องการสมัครเรียน--</option>
                {Array.isArray(DataMajor) &&
                  DataMajor.map((i) =>
                    i.value.startsWith(9) ? (
                      <option value={i.value}>{i.label}&nbsp;( แม่สอด )</option>
                    ) : (
                      <option value={i.value}>{i.label}&nbsp;( กำแพงเพชร )</option>
                    )
                  )}
              </SelectField>
            </div>
          )}
          <div className="col-12 d-flex justify-content-end ">
            <Button
              iconBefore={<FloppyDiskIcon />}
              appearance="primary"
              intent="success"
              onClick={Submit}
              disabled={
                Faculty === "1"
                  ? Major === "" || Maj === ""
                    ? true
                    : false
                  : Major === ""
                  ? true
                  : false
              }
            >
              บันทึก
            </Button>
          </div>
        </Pane>
      </Pane>
    </>
  );
}

export default FormRegisterMaster;
